import { transport } from 'config/transport';

export function callApiExportNoiTruYearlyReport(congDoanId, academicYear, pdf = false) {
    return transport.get(`/noitru/${congDoanId}/thuchi/exportReportAnnually`, { params: { academicYear, pdf }, responseType: 'blob' });
}
